import { Link, useNavigate } from "react-router-dom";
import { completeOnboarding } from "../lib/auth";

const steps = [
  { title: "Upload inventory", description: "Import a CSV or JSON file and match broker records to canonical listings.", to: "/upload" },
  { title: "Review canonical listings", description: "Browse deduplicated property facts and inspect cluster membership.", to: "/properties" },
  { title: "Explore analytics", description: "Compare neighborhood pricing, room mix, volume, and trends.", to: "/analytics" },
  { title: "Invite other brokers", description: "Provision a local broker credential from the broker administration workspace.", to: "/admin/brokers" },
] as const;

export function Onboarding() {
  const navigate = useNavigate();

  function finishOnboarding() {
    completeOnboarding();
    navigate("/properties", { replace: true });
  }

  return (
    <section className="mx-auto max-w-5xl">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-mls-600">Getting started</p>
      <h1 className="mt-2 text-4xl font-semibold tracking-tight text-slate-950">Welcome to MLS2</h1>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-600">
        Your broker workspace is ready. These four steps cover the core dashboard workflow.
      </p>

      <ol className="mt-8 grid gap-5 sm:grid-cols-2">
        {steps.map((step, index) => (
          <li className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" key={step.to}>
            <span className="grid size-9 place-items-center rounded-full bg-mls-50 text-sm font-bold text-mls-900">{index + 1}</span>
            <h2 className="mt-5 text-lg font-semibold text-slate-950">{step.title}</h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">{step.description}</p>
            <Link className="mt-4 inline-flex text-sm font-semibold text-mls-600 hover:underline" to={step.to}>Open step →</Link>
          </li>
        ))}
      </ol>

      <button
        className="mt-8 rounded-lg bg-mls-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-mls-600"
        type="button"
        onClick={finishOnboarding}
      >
        Continue to properties
      </button>
    </section>
  );
}
